import { XpressDisciplinaryStatus, XpressPriorityType, XpressOffenseType, XpressDisciplinaryType } from 'app/models';

export class AddOrUpdateDisciplinary {
    Id: number = 0;
    DisciplinaryStatusId: XpressDisciplinaryStatus | null = null;
    PriorityTypeId: XpressPriorityType | null = null;
    OffenseTypeId: XpressOffenseType | null = null;
    DisciplinaryTypeId: XpressDisciplinaryType = XpressDisciplinaryType.Manually;
    CodeConductId: number | null = null;
    ComplaintUserId: number | null = null;
    OffenseDateTime: Date | null = null;
    SourceCase: string = '';
    Channel: string | null = null;
    Note: string | null = null;
    IsCustomerAffected: boolean = false;
    CustomerName: string | null = null;
    CustomerEmail: string | null = null;
    CustomerPhone: string | null = null;
}
